import { twJoin, twMerge } from 'tailwind-merge';

import AppStoreBadges from './app-store-badges';
import FooterLogo from './footer-logo';
import SocialMediaIcons from './social-media-icons';

import type { I18NFromComponent } from '../../../utils';
import type AppStoreRating from './app-store-rating';
import type { Locale } from '@tuic/i18n';
import type { ComponentProps, FC, PropsWithChildren } from 'react';

type Props = {
  socialMedia?: ComponentProps<typeof SocialMediaIcons>;
  appStoreBadges?: ComponentProps<typeof AppStoreBadges>;
  locale?: Locale;
  i18n?: I18NFromComponent<typeof AppStoreRating>;
};

type TMetaNavigation = FC<Props> & {
  Title: FC<
    PropsWithChildren<{
      className?: string;
    }>
  >;
};

const Title: TMetaNavigation['Title'] = ({ className, children }) => {
  return (
    <h3
      className={twMerge(
        twJoin(
          'mb-[0.5em] text-center text-[1.25rem] font-semibold leading-[1.875rem] lg:text-left',
          className,
        ),
      )}
    >
      {children}
    </h3>
  );
};

/**
 * Renders the meta navigation of the footer.
 */
const MetaNavigation: TMetaNavigation = ({
  appStoreBadges,
  socialMedia,
  locale,
  i18n,
}) => {
  return (
    <div className="flex flex-col px-[42.5px] py-0 lg:h-full lg:items-start lg:justify-between lg:p-0 [&>div]:mb-10">
      <div className="flex lg:hidden mr-[-1.875rem]">
        <FooterLogo locale={locale} />
      </div>
      <div>
        <SocialMediaIcons {...socialMedia} />
      </div>
      <div>
        <AppStoreBadges {...appStoreBadges} i18n={i18n} />
      </div>
      <div className="hidden lg:flex max-w-[300px]">
        <FooterLogo locale={locale} />
      </div>
    </div>
  );
};

MetaNavigation.Title = Title;

export default MetaNavigation;
